<div
  *ngIf="
    event?.data?.event_type == MAADHANTHIRA_SANDHA ||
    event?.data?.event_type == POTHU_VARAVU_SELAVU
  "
  class="card-preview"
>
  <div
    [ngClass]="event?.data?.event_deleted == 1 ? 'disable' : ''"
    class="fuse-card p-12"
  >
    <label style="padding: 6px">#{{ barracks[event?.data?.barrack_id] }}</label>

    <div
      class="p-16 pb-0"
      fxLayout="row wrap "
      fxLayoutGap="32px"
      fxLayoutAlign="space-between center"
    >
      <div class="pr-16 top hash" fxLayout="column">
        <div
          *ngIf="
            event?.data?.status == -1 &&
            (event.data.enable_edit_btn ||
              event.data.enable_delete_btn ||
              event.data.enable_copy_btn)
          "
          class="bar"
        >
          <button
            class="menu"
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Example icon-button with a menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngIf="event.data.enable_edit_btn"
              (click)="event.data.editEvent('edit', event)"
            >
              <mat-icon>mode_edit</mat-icon>
              <span>திருத்து</span>
            </button>
            <button
              (click)="event.data.deleteEvent('edit', event)"
              mat-menu-item
              *ngIf="event.data.enable_delete_btn"
            >
              <mat-icon>delete</mat-icon>
              <span>நீக்கு</span>
            </button>
            <button mat-menu-item *ngIf="event.data.enable_copy_btn">
              <mat-icon>file_copy</mat-icon>
              <span>{{ "Copy File" | translate }}</span>
            </button>
          </mat-menu>
        </div>

        <div class="h2 nigalvu">#{{ event?.data?.event_id }}</div>
        <div class="h3 secondary-text">
          <button
            mat-button
            style="background-color: blue; color: #fff; font-size: 12px"
            color="primary"
          >
            {{ event?.data?.event_place[0]?.place_data.place_name }}
          </button>
        </div>

        <div class="mt-4 make">
          உருவாக்கப்பட்டது :{{ event?.data?.created_member_name }} #{{
            event?.data?.event_entered_userId
          }}
          {{ event?.data?.event_created_time | date: "dd/MM/yyyy hh:mm a" }}
        </div>
        <div class="mt-4 make">
          மாற்றப்பட்டது :{{ event?.data?.updated_member_name }} #{{
            event?.data?.event_updated_user_id
          }}
          {{ event?.data?.event_update_time | date: "dd/MM/yyyy hh:mm a" }}
        </div>
      </div>

      <div fxLayout="column" class="top second">
        <div class="h1">{{ event?.data?.event_title }}</div>
        <br />
        <div class="h2">
          {{ event?.data?.event_start_time | date: "dd/MM/yyyy hh:mm a" }}
          -
          {{ event?.data?.event_end_time | date: "dd/MM/yyyy hh:mm a" }}
        </div>
        <div class="mb-4 mt-12">
          <button
            mat-flat-button
            style="background-color: green; color: #fff; width: 165px"
            [disabled]="!event.data.enable_contribution_btn"
            (click)="
              event.data.enable_contribution_btn
                ? event.data.openContribution(event)
                : null
            "
            color="primary"
            class="mr-4 contri"
          >
            {{
              event?.data?.totalContribution | currency: "INR":"symbol":"1.0-0"
            }}
          </button>
          <button
            *ngIf="event.data.event_type != 61"
            class="mr-4"
            [disabled]="!event.data.enable_expense_btn"
            mat-flat-button
            style="background-color: red; color: #fff; width: 165px"
            (click)="
              event.data.enable_expense_btn
                ? event.data.openExpense(event)
                : null
            "
            color="primary"
          >
            {{ event?.data?.totalExpense | currency: "INR":"symbol":"1.0-0" }}
          </button>
        </div>
      </div>

      <div class="top third" fxLayout="column">
        <div class="bar1">
          <button
            *ngIf="
              event.data.enable_edit_btn ||
              event.data.enable_delete_btn ||
              event.data.enable_copy_btn
            "
            class="menu"
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Example icon-button with a menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngIf="event.data.enable_edit_btn"
              (click)="event.data.editEvent('edit', event)"
            >
              <mat-icon>mode_edit</mat-icon>
              <span>திருத்து</span>
            </button>
            <button mat-menu-item *ngIf="event.data.enable_delete_btn">
              <mat-icon>delete</mat-icon>
              <span>நீக்கு</span>
            </button>
            <button mat-menu-item *ngIf="event.data.enable_copy_btn">
              <mat-icon>file_copy</mat-icon>
              <span>{{ "Copy File" | translate }}</span>
            </button>
          </mat-menu>
        </div>

        <br />
        <div class="icon">
          <button
            mat-mini-fab
            class="light-blue-A700 mr-4"
            (click)="event.data.finalAction('question', event)"
            *ngIf="event.data.enable_question_btn"
          >
            <mat-icon>help_outline </mat-icon>
          </button>
          <button
            mat-mini-fab
            class="green-600 mr-4"
            (click)="event.data.finalAction('approve', event)"
            *ngIf="event.data.enable_approve_btn"
          >
            <mat-icon>check_circle </mat-icon>
          </button>
          <button
            mat-mini-fab
            class="warn"
            *ngIf="event.data.enable_question_btn"
            (click)="event.data.finalAction('reject', event)"
          >
            <mat-icon>not_interested</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
